import React, { FC, useMemo } from 'react';

import IconCustom from 'gatsby-theme-gaviscon/src/components/common/IconCustom';
import './ProductFormats.scss';
import { Link } from 'gatsby';

const ProductFormats: FC<ProductPageTypes.IProductFormats> = ({
  otherFormats,
  currentFormat,
  title,
}) => {
  const formats = useMemo(
    () =>
      [...otherFormats, ...currentFormat].sort((a, b) =>
        a.properties.type[0] > b.properties.type[0] ? 1 : -1
      ),
    [otherFormats, currentFormat]
  );

  return (
    <div className="product-formats" data-testid="product-formats">
      <strong className="product-formats__title">{title}</strong>
      <ul className="product-formats__list">
        {formats.map(({ properties: { type: [icon], label, link } }, idx) => (
          <li key={icon + idx} className="product-formats__list-item">
            {link?.length ? (
              <Link
                className="product-formats__link product-formats__link--inactive"
                to={link[0].url}
                title={label}
              >
                <div className="product-formats__circle">
                  <IconCustom icon={`${icon}-format`} />
                </div>
              </Link>
            ) : (
              <div className="product-formats__link product-formats__link--active" title={label}>
                <div className="product-formats__circle">
                  <IconCustom icon={`${icon}-format`} />
                </div>
              </div>
            )}
            {label ? (
              <span className="product-formats__label">{label}</span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductFormats;
